import { memo } from 'react';
import {
    CommonCellProps,
    STROKE_WIDTH,
    SedieRoadMapCellProps,
    useSedieRoadMapCellColorText,
} from '../hook';
import { ROAD_MAP_TYPE } from '../../../lobby/constants';
const PointRoadCell = ({ record: { Win, WinPoint }, size }: SedieRoadMapCellProps & CommonCellProps) => {
    const { color, text } = useSedieRoadMapCellColorText(ROAD_MAP_TYPE.POINT_ROAD, WinPoint);
    return (
        <svg width={size} height={size}>
            {Win >= 0 && (
                <>
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={size / 2 - STROKE_WIDTH / 2}
                        fill="transparent"
                        stroke={color}
                        strokeWidth={STROKE_WIDTH}
                    />
                    <text
                        x={size / 2}
                        y={size / 2+2}
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fill={color}
                        fontSize={size * 0.7}
                        fontWeight="bold"
                    >
                        {text}
                    </text>
                </>
            )}
        </svg>
    );
};
export default memo(PointRoadCell);
